import { Outlet } from 'react-router-dom'
import { BottomNav } from '@/components/BottomNav'
import { Sidebar } from '@/components/Sidebar'
import { Header } from '@/components/Header'

export function DashboardLayout() {
  return (
    <div className="flex h-screen min-h-0 overflow-hidden bg-background">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Header />
        <main className="min-h-0 flex-1 overflow-y-auto bg-muted/40">
          <div className="mx-auto w-full max-w-[1440px] px-4 pb-[calc(5.75rem+env(safe-area-inset-bottom))] pt-4 lg:px-8 lg:py-5">
            <Outlet />
          </div>
        </main>
        <BottomNav />
      </div>
    </div>
  )
}
